import script from "./NotificationDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationDisplay.vue?vue&type=style&index=0&id=035bad17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-035bad17"]])

export default __exports__